module.exports = __webpack_public_path__ + "src/assets/img/usb_01_de.f087fd10.png";